import { CaseStudy } from '../types'

export const caseStudiesData: CaseStudy[] = [
  {
    id: 'decision-intelligence',
    domain: 'ENTERPRISE AI · DECISION INTELLIGENCE',
    title: 'MARS at Genentech',
    company: 'Genentech (Roche)',
    role: 'Product Manager',
    timeframe: '2025 to Present',
    heroMetric: '$1.2B+',
    heroMetricContext: 'in annual marketing spend directed',
    keyMetrics: [],
    summary:
      "A $1.2B+ Bayesian marketing mix model on Google's Meridian, directing spend across 17+ brands. The first pharma platform built on Meridian, and the decision layer that turns model output into committed budget.",
    context: '',
    problem: '',
    constraints: '',
    decisionFramework: '',
    execution: '',
    impact: '',
    lessons: '',
  },
  {
    id: 'walmart-marketplace',
    domain: 'MARKETPLACE · GROWTH & RISK',
    title: 'Experimentation at Walmart',
    company: 'Walmart',
    role: 'Product Manager',
    timeframe: '2023 to 2025',
    heroMetric: '125K+',
    heroMetricContext: 'sellers managed via experimentation',
    keyMetrics: [],
    summary:
      'Experimentation-driven seller performance systems. Factorial and multivariate testing to put incentives and enforcement where they measurably changed behavior, across 125K+ sellers.',
    context: '',
    problem: '',
    constraints: '',
    decisionFramework: '',
    execution: '',
    impact: '',
    lessons: '',
  },
  {
    id: 'amazon-recommendations',
    domain: 'RECOMMENDATION SYSTEMS · BILLION SCALE',
    title: 'Ranking and Measurement at Amazon',
    company: 'Amazon',
    role: 'Product Manager',
    timeframe: '2021 to 2023',
    heroMetric: '~1B',
    heroMetricContext: 'recommendations a day',
    keyMetrics: [],
    summary:
      'Ranking, recommendation, and measurement at marketplace scale. Roughly one billion recommendations a day, where latency and guardrails mattered as much as model quality. Work directly adjacent to ad ranking and measurement.',
    context: '',
    problem: '',
    constraints: '',
    decisionFramework: '',
    execution: '',
    impact: '',
    lessons: '',
  },
]
